import classNames from 'classnames';
import React, { JSX, ReactNode } from 'react';

interface Props {
  htmlFor?: string;
  className?: string;
  isRequired?: boolean;
  children: ReactNode;
}

export default function FormLabel({ children, htmlFor, className, isRequired }: Props): JSX.Element {
  return (
    <label className={classNames('block text-gray-700 mb-2 font-semibold', className)} htmlFor={htmlFor}>
      {children} {isRequired ? '*' : ''}
    </label>
  );
}
